import React, { Fragment, memo, useMemo, useState } from 'react';
import { ChevronArrowDownIcon } from '../../assets/icons/ChevronArrowDownIcon';
import { useMergedClassNames } from '../../utils/HTMLutils';
import FloatingPanel from '../floatingPanel/FloatingPanel';
import './DropdownSelector.scss';
const rootClassName = 'dropdown-selector';

export interface DropdownSelectorOption {
  label: string;
  value: string;
}

export interface DropdownSelectorProps {
  value: string | null;
  options?: DropdownSelectorOption[];
  onChange: (value: string | null) => void;
  placeholder?: string;
  w100?: boolean;
}

function DropdownSelector(props: DropdownSelectorProps) {
  const [opened, setOpened] = useState<boolean>(false);

  const label = useMemo(() => {
    return (
      props.options?.find((opt) => opt.value === props.value)?.label ??
      props.placeholder ??
      ''
    );
  }, [props.options, props.placeholder, props.value]);

  const options = useMemo(() => {
    return (
      <Fragment>
        {props.options?.map((opt, i) => {
          return (
            <button
              key={i}
              onClick={() => {
                props.onChange(opt.value);
                setOpened(false);
              }}
              className='nunito'
            >
              {opt.label}
            </button>
          );
        })}
      </Fragment>
    );
  }, [props]);

  return (
    <div
      className={useMergedClassNames([
        `${rootClassName}-wrapper`,
        props.w100 ? 'w-100' : '',
        opened ? 'opened' : '',
      ])}
    >
      <button
        className={useMergedClassNames([
          rootClassName,
          props.w100 ? 'w-100' : '',
          opened ? 'opened' : '',
        ])}
        onClick={() => {
          setOpened(!opened);
        }}
      >
        <div className={`${rootClassName}-label nunito`}>{label}</div>
        <div
          className={useMergedClassNames([
            `${rootClassName}-icon`,
            opened ? 'opened' : '',
          ])}
        >
          <ChevronArrowDownIcon />
        </div>
      </button>
      <FloatingPanel
        opened={opened}
        setOpened={setOpened}
        className={`${rootClassName}-menu`}
      >
        {options}
      </FloatingPanel>
    </div>
  );
}

export default memo(DropdownSelector);
